export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "partners": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Our Partners"])}
      },
      "de": {
        "partners": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unsere Partner"])}
      }
    }
  })
}
